module.exports = __webpack_public_path__ + "static/img/Helvetica-Regular.809ac18.svg";